<template>
	<div class="home home-wrap">
		<div class="shop-container">
			<div class="nav-wrap">
				<all-classify></all-classify>
				<div class="banner-list">
					<el-carousel arrow="always" height="440px" :interval="7000">
						<el-carousel-item v-for="(item,index) in bannerArr" :key="index">
							<img v-lazy="item.img" :alt="item.name" @click="swiperClick(item)">
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<new-shop-list :newsList="newsShopList" title="部分拍品展示" :showMore="true"></new-shop-list>
			
			<new-shop-list
				v-if="lowPriceList.length"
				:newsList="lowPriceList"
				title="低价专区"
				:showMore="false"
			></new-shop-list>
			<new-shop-list
				v-if="myFollowList.length"
				:newsList="myFollowList"
				title="我关注的竞拍"
				:showMore="false"
			></new-shop-list>
			
			<activity-img></activity-img>
		</div>
		<ScrollToTop></ScrollToTop>
		<div :style="{display: showAdopt ? 'block' : 'none'}" class="adopt-box">
			<div class="adopt-con">
				<div class="img-con" @click="toUrl">
					<img class="adopt-img" :src="$store.state.config.next_issue_pc_bg_image" />
					<div class="time">{{ getTime.day }}</div>
					<div class="time hour">{{ getTime.hour }}</div>
					<div class="time min">{{ getTime.time }}</div>
				</div>
				<i class="el-icon-circle-close adopt-icon" @click="closeAdopt"></i>
			</div>
		</div>
		<!-- <el-dialog title="领取优惠券" :visible.sync="centerDialogVisible" width="400px" center>
			<div class="coupon-list">
				<div class="coupon-wrap" v-for="(item,index) in couponList" :key="index">
					<div class="content">
						<div class="price">
							<span class="num">{{item.name}}</span>
						</div>
						<div class="desc">{{item.expression1}}&nbsp;&nbsp;{{item.expression2}}</div>
						<div class="time">{{item.stime}}&nbsp;--&nbsp;{{item.etime}}</div>
					</div>
					<div class="status">
						<a href="javascript:;" @click="userGetCoupon(item.id)">立即领取</a>
					</div>
				</div>
			</div>
		</el-dialog> -->


		<el-dialog title="平台协议" :visible.sync="tipsVisible" width="40%" center :before-close="beforeCloseTips">
			<div>
				<div class="platform_desc">
					<div v-html="$store.state.config.platform_desc"></div>
				</div>

				<div slot="footer" class="dialog-footer-tips">
					<img v-if="checkImg" src="~@/assets/images/check-h.png" alt="" @click="toggleTips">
					<img v-else src="~@/assets/images/check.png" alt="" @click="toggleTips">

					同意平台协议

					<el-button size="small" type="primary" @click="closeTips">确认</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// @ is an alias to /src

	import AllClassify from "@/components/common/AllClassify.vue";
	import NewShopList from "@/components/home/NewShopList.vue";
	import ActivityImg from "@/components/home/ActivityImg.vue";
	import ProductLoft from "@/components/home/ProductLoft.vue";
	import OneShop from "@/components/home/OneShop.vue";
	import ScrollToTop from "@/components/common/ScrollToTop.vue";
	import { mapState, mapActions } from "vuex";
	import { apiBaseUrl } from '@/config/env.js';
	import { isSafeRedirect } from '@/utils/index.js';

	import {
		showLoading,
		hideLoading
	} from '../utils/loading'



	export default {
		data() {
			return {
				allClassifyData: [], //所有商品分类
				bannerArr: [],
				newsShopList: [], //新品上市,
				lowPriceList: [], // 低价专区
				myFollowList: [], // 我关注的拍卖
				loftData: [],
				couponList: [], //优惠券列表
				centerDialogVisible: false,
				checkImg: false,
				tipsVisible: false,
				time: 0,
				timer: null,
				loading: false,
				showAdopt: false
			};
		},
		name: "Home",
		components: {
			AllClassify,
			NewShopList,
			ProductLoft,
			// ReCommend,
			OneShop,
			ScrollToTop,
			ActivityImg
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				// 通过 `vm` 访问组件实例,将值传入fromPath
				vm.fromPath = from.path
				if (vm.fromPath == "/login" && vm.couponList.length > 0) {
					vm.centerDialogVisible = true
				}
			})
		},
		mounted() {
			showLoading();
			this.loading = true

			let event = this.getUrlParam('event');
			if (event && event === 'unsubscribeendremind') {
				this.closeAuctionEndTimeRemind();
			}
			this.$api.addRecord({
				'type': '4',
				'api_method': "pages.gethomepageconfig",
				"platform": "1"
			})


			this.getHomeSlider();
			this.getRecomendList();
			this.getLowPriceList();
			this.getMyFollowAuctions();
			this.getLoftData();
			this.recordInviteVisit();
			//this.getCouponList();
			if (this.$storage.get('homeTips')) {
				this.tipsVisible = false
			} else {
				this.tipsVisible = true
			}

			if(this.$storage.get("userToken") && !this.$storage.get("userInfo")) {
				this.$api.userInfo().then(result => {
					if (result.status) {
						let userInfo = result.data;
						this.getUserInfo(userInfo);
					}
				});
			}


			this.timer = setTimeout(() => {
				if (this.loading) {
					showLoading({
						text: '这会人太多啦，请稍后再试~'
					})
				}
			}, 10000)
			//检查浏览器
			if (!window.WebSocket) {
				this.$message({
					message: '浏览器版本过低，请升级浏览器或使用Chrome浏览器',
					type: 'warning'
				})
			}
		},
		computed: {
			getTime() {
				let time = this.$store.state.config.next_issue_start_time
				const currentDate = new Date();
				const startDate = new Date(time);
				const timeDiff = startDate - currentDate;
				const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)); // 天数
				const hoursDiff = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)); // 小时数
				const minutesDiff = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60)); // 分钟数
				return {
					day: daysDiff,
					hour: hoursDiff,
					time: minutesDiff
				}
			},
			// getStatus() {
			// 	if(this.$storage.get('home_adopt')) {
			// 		return this.$storage.get('home_adopt') == 'true'
			// 	}
			// 	return this.adoptstatus
			// }
		},
		methods: {
		    ...mapActions(["getUserInfo"]),
			recordInviteVisit() {
				const code = this.$storage.get('invitecode');
				if (code && this.$storage.get("userToken")){
					return this.$api.recordInviteActivityVisit({
						code,
						visited_page: `${apiBaseUrl}web/`
					}).then(() => {
						this.$storage.remove('invitecode');
					});
				}
			},
			closeAuctionEndTimeRemind() {
				this.$api.closeAuctionEndTimeRemind({}).then(res => {
					this.$message({
						message: res.msg || (res.status ? '关闭成功' : '关闭失败'),
						type: res.status ? 'success' : 'warning'
					})
				})
			},
			getUrlParam(paraName) {
				let url = window.location.toString();
				let arrObj = url.split('?');

				if (arrObj.length > 1) {
					let arrPara = arrObj[1].split('&');
					let arr;
					for (let i = 0; i < arrPara.length; i++) {
						arr = arrPara[i].split('=');
						if (arr != null && arr[0] == paraName) {
							if (arr[1].indexOf('#')) {
								let str;
								str = arr[1].split('#');
								return str[0];
							}
							return arr[1];
						}
					}
					return '';
				} else {
					return '';
				}
			},
			toUrl() {
				const url = this.$store.state.config.next_issue_click_url;
				if (isSafeRedirect(url)) {
					window.open(url,'_blank')
				}
			},
			closeAdopt() {
				this.showAdopt = false
				console.log('fvdfvfd', this.showAdopt)
				this.$storage.set('pchome_adopt', 'hide')
			},
			toggleTips() {
				this.checkImg = !this.checkImg
			},
			closeTips() {
				this.beforeCloseTips()
			},
			beforeCloseTips() {
				if (this.checkImg) {
					this.tipsVisible = false
					this.$storage.set('homeTips', 'hide')
					if(!this.$storage.get('pchome_adopt') && this.$store.state.config.next_issue_status == 1) {
						this.showAdopt = true
					}
				} else {
					this.$message({
						message: '请先同意平台协议',
						type: 'warning'
					})
				}
			},
			// /点击
			swiperClick(v) {
				// type 1 url 直接跳转
				// 2 商品
				//  3 文章
				// 4  文章分类
				// 5 智能表单
				// window.open('https://www.baidu.com','_blank')
				this.$api.addRecord({
					'type': '5',
					'api_method': "advert.getcarousellists",
					"platform": "1",
					"code": v.code,
					"rel_id": v.id
				})
				if (v.type == 1 && v.val!='#') {
					if (isSafeRedirect(v.val)) {
						window.open(v.val, '_blank')
					}
					return
				}

				if (v.type == 2) {
					this.$router.push({
						path: `detail/${v.id}`,
					})
					return
				}
			},
			getLoftData() {
				this.$api.homeLoftData().then(res => {
					if (res.status) {
						this.loftData = res.data;
					}
				});
			},
			// 获取低价专区列表
			getLowPriceList() {
				const params = {
					limit: 10,
					page: 1,
					order: 'latest_price asc'
				};
				this.$api.lowpriceList(params).then(res => {
					if (res.status && res.data && res.data.list) {
						this.lowPriceList = res.data.list;
					}
				});
			},
			// 我关注的拍卖
			getMyFollowAuctions() {
				const params = {
					limit: 10,
					page: 1
					//order: 'latest_price asc'
				};
				this.$api.myFollowAuctions(params).then(res => {
					if (res.status && res.data && res.data.list) {
						this.myFollowList = res.data.list;
					} else {
						this.myFollowList = [];
					}
				});
			},
			//获取首页banner轮播
			getHomeSlider() {
				// let data={
				//   code: "pc_home_slider"
				// }
				let data = {
					code: "tpl1_slider"
				};
				this.$api.slider(data).then(res => {
					if (res.status) {
						this.bannerArr = res.data.list;
					}
				});
			},
			//获取新品上市
			getRecomendList() {

				this.$api.auctionList({
					is_rec: 1,
					limit:9999
				}).then(res => {
					if (res.status) {
						this.newsShopList = res.data.list
					}

					clearTimeout(this.timer)
					this.loading = false
					hideLoading()
				});
				return
				/*
				let data = {
					where: JSON.stringify({
						recommend: 1
					})
				};
				let option = {
					page: 1,
					limit: 10
				};
				let params = Object.assign(data, option);
				this.$api.goodsList(params).then(res => {
					if (res.status) {
						this.newsShopList = res.data.list;
					}
				});*/
			},
			// 获取商户优惠券信息
			getCouponList() {
				this.$api.couponList().then(res => {
					if (res.status) {
						this.couponList = res.data;
						// console.log('couponList', this.couponList)
						if (res.data.length > 0) {
							this.centerDialogVisible = true
						}
					}
					if(this.$storage.get('homeTips') && !this.$storage.get('pchome_adopt') && this.$store.state.config.next_issue_status == 1) {
						this.showAdopt = true
					}
				});
			},
			//领取优惠券
			userGetCoupon(id) {
				this.$api.getCoupon({
					promotion_id: id
				}).then(res => {
					if (res.status) {
						this.$msg(res.msg)
					} else {
						this.$msg(res.msg, 'warning')
					}
					// this.centerDialogVisible=false;
				});
			}
		},
		deactivated() {
			this.centerDialogVisible = false;
		}
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/mixin.scss";
	@import "@/assets/css/variable.scss";

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.platform_desc {
		padding: 20px;
		max-height: 300px;
		min-height: 50px;
		overflow-y: auto;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	.nav-wrap {
		width: 100%;
		position: relative;
		height: 440px;

		.banner-list {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			width: 100%;
			height: 440px;
			z-index: 10;
			overflow: hidden;
			width: 986px;
			margin-left: 238px;

			img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}

	.banner {
		width: 100%;
		height: 376px;
	}

	.coupon-list {
		flex-direction: column;
		justify-content: center;
		margin: 0 auto;
	}

	.coupon-wrap:nth-child(3n) {
		margin-right: auto;
	}

	.dialog-footer-tips {
		position: relative;
		padding: 20px;
		display: flex;
		align-items: center;

		img {
			width: 25px;
			height: 25px;
			margin-right: 10px;
		}

		button {
			position: absolute;
			right: 30px;
		}
	}
	.adopt-box {
		width: 100vw;
		height: 100vh;
		position: fixed;
		left: 0;
		top: 0;
		background-color: rgba(0, 0, 0, .3);
		z-index: 99999999;
		.adopt-con {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			width: 679px;
			text-align: center;
			.adopt-img {
				width: 100%;
			}
			.adopt-icon {
				color: #fff;
				font-size: 30px;
				margin-top: 20px;
				cursor: pointer;
			}
			.img-con {
				position: relative;
				.time {
					position: absolute;
					right: 583px;
					top: 160px;
					font-size: 68px;
					font-weight: 700;
					font-style: oblique;
					color: #000;
				}
				.hour {
					right: 464px;
				}
				.min {
					right: 341px;
				}
			}
		}
	}
</style>
